import React from 'react'
import { get, keys, isEmpty, isPlainObject } from 'lodash'
import actions from '../../actions/AdminToolRuns'
import Component from '../common/Component'
import CreateForm, { defaultPropTypes, connectCreateForm } from '../common/CreateForm'
import SelectField from '../common/SelectField'
import ArgsField from '../common/ArgsField'
import ConnectedFileUploaderComponent from '../common/ConnectedFileUploaderComponent'

export class AdminToolRunCreate extends Component {
  static propTypes = defaultPropTypes

  constructor(props) {
    super(props)

    this.state = { currentTool: '' }
  }

  get toolOptions() {
    return keys(this.props.configuration.tools, (toolName) => ({
      text: toolName,
      value: toolName
    }))
  }

  get arguments() {
    return this.state.args || ''
  }

  argTemplate = (toolName) => {
    return get(this.props.configuration.tools[toolName], 'template') || {}
  }

  showFileUpdateComponent = (toolName) => {
    return get(this.props.configuration.tools[toolName], 'accepts_file')
  }

  // Prefill only the free-text keys with their labels -- a picker key
  // ({label:, options:}) has no sensible label-as-value to prefill, and
  // starting it with one would show a bogus preselected option instead of
  // leaving the picker for the operator to choose from.
  initialArgs = (toolName) => {
    const template = this.argTemplate(toolName)
    return Object.keys(template).reduce((initial, key) => {
      if (!isPlainObject(template[key])) {
        // eslint-disable-next-line no-param-reassign
        initial[key] = template[key]
      }
      return initial
    }, {})
  }

  handleChange = (attributes) => {
    if (attributes.name !== this.state.currentTool) {
      this.setState({ currentTool: attributes.name })
      // eslint-disable-next-line no-param-reassign
      attributes.args = this.initialArgs(attributes.name)
    }
  }

  render() {
    return (
      <CreateForm {...this.props} handleChange={this.handleChange} attributes={{ args: {} }}>
        <SelectField
          key="name"
          name="name"
          label="Tool"
          options={this.toolOptions}
        />

        {!isEmpty(this.argTemplate(this.state.currentTool)) && (
          <ArgsField
            key="args"
            name="args"
            template={this.argTemplate(this.state.currentTool)}
          />
        )}

        {this.showFileUpdateComponent(this.state.currentTool) && (
          <ConnectedFileUploaderComponent
            name="blob_id"
            label="File"
            disabled={false}
          />
        )}
      </CreateForm>
    )
  }
}

export default connectCreateForm(AdminToolRunCreate, 'AdminToolRun', 'admin_tool_runs', actions)
